import "./block-tabs.scss";

const $ = jQuery.noConflict();

function initTabsSlider() {
    $(".slider-tabs").each(function onEach() {
        // eslint-disable-next-line no-undef, no-new
        new Swiper($(this)[0], {
            effect: "fade",

            fadeEffect: {
                crossFade: true,
            },

            loop: true,

            a11y: {
                prevSlideMessage: siteObject.strings.next_slide,
                nextSlideMessage: siteObject.strings.next_slide,
            },

            navigation: {
                nextEl: ".slider-tabs-next",
                prevEl: ".slider-tabs-prev",
            },

            pagination: {
                el: ".slider-tabs-pagination",
                type: "fraction",
            },

            keyboard: {
                enabled: true,
                onlyInViewport: true,
            },
        });
    });
}

$(document).ready(function onReady() {
    initTabsSlider();
});

if (window.acf) {
    window.acf.addAction("render_block_preview", initTabsSlider);
}
